export const features = [
    {
      name: "Antenna",
      position: [-1.55, 4.55, 0],
      image: "/images/antenna.webp",
      title: "HyperWave Signal Receiver",
      description:
        "The antenna allows FILBOT to receive commands from anywhere, ensuring quick and reliable responses.",
    },
    {
      name: "Eyes",
      position: [-0.08, 3.85, 1.2],
      image: "/images/eyes.webp",
      title: "Emotion-Aware Optic Sensors",
      description:
        "FILBOT's eyes adjust to light, scan surroundings, and (allegedly) read your mood through facial expressions.",
    },
    {
      name: "Arms",
      position: [1.55, 2.86, 0],
      image: "/images/arms.webp",
      title: "Multi-Purpose Servo Arms",
      description:
        "Each arm is powered by torque-enhanced servos, capable of handling anything from hugging you to typing 200 WPM.",
    },
    {
      name: "Chest Panel",
      position: [-0.55, 2.3, 1.05],
      image: "/images/chest-panel.webp",
      title: "Touchscreen Control Interface",
      description:
        "FILBOT's control panel manages system modes, diagnostics, and interactive features.",
    },
    {
      name: "Circuit Panel",
      position: [0.55, 2.05, 1],
      image: "/images/circuit-panel.webp",
      title: "Open Hardware Hub",
      description:
        "FILBOT is fully open-source, plug in any compatible module and watch it learn something new. A true tinkerer's dream.",
    },
    {
      name: "Body Core",
      position: [-0.05, 1.65, 1.05],
      image: "/images/body-core.webp",
      title: "Quantum-Core Power Source",
      description:
        "Inside FILBOT is a Quantum Reactor that runs on pure curiosity and sunlight. Runs for 900 years, or your money back.",
    },
    {
      name: "Wheels",
      position: [-0.95, 0.55, 1.1],
      image: "/images/wheels.webp",
      title: "OmniDrive Navigation System",
      description:
        "FILBOT rolls smoothly anywhere, from hardwood floors to space stations.",
    },
  ];  